module.exports = __webpack_public_path__ + "img/personnel_access_feature_05.cc418abf.jpg";